module.exports = __webpack_public_path__ + "static/media/Marine.ce4ce1f9.png";